import { SvgIconType } from '@integration-app/react'
import {
  WorkspaceElementState,
  WorkspaceElementType,
} from '@integration-app/sdk'

import { routeTo } from 'routes/Workspaces/Workspace/routes-constants'

export const WORKSPACE_ELEMENT_TYPE_TO_ICON_TYPE: Partial<
  Record<WorkspaceElementType, SvgIconType>
> = {
  [WorkspaceElementType.Integration]: SvgIconType.AppEntity,
  [WorkspaceElementType.Connection]: SvgIconType.Link,
  [WorkspaceElementType.Customer]: SvgIconType.UserEntity,
  [WorkspaceElementType.Flow]: SvgIconType.FlowEntity,
  [WorkspaceElementType.FlowInstance]: SvgIconType.FlowEntity,
  [WorkspaceElementType.FlowRun]: SvgIconType.FlowsEntity,
  [WorkspaceElementType.Action]: SvgIconType.ActionEntity,
  [WorkspaceElementType.ActionInstance]: SvgIconType.ActionEntity,
  [WorkspaceElementType.DataSource]: SvgIconType.DataSourceEntity,
  [WorkspaceElementType.DataSourceInstance]: SvgIconType.DataSourceEntity,
  [WorkspaceElementType.FieldMapping]: SvgIconType.FieldMappingEntity,
  [WorkspaceElementType.FieldMappingInstance]: SvgIconType.FieldMappingEntity,
  [WorkspaceElementType.ExternalEventSubscription]:
    SvgIconType.AppEventSubscriptionEntity,
  [WorkspaceElementType.AppEventType]: SvgIconType.AppEventSubscriptionEntity,
  [WorkspaceElementType.AppEventSubscription]:
    SvgIconType.AppEventSubscriptionEntity,
}

export const WORKSPACE_ELEMENTS_TYPE_TO_ROUTE: Partial<
  Record<WorkspaceElementType, string>
> = {
  [WorkspaceElementType.Integration]: routeTo.integrations(),
  [WorkspaceElementType.Connection]: routeTo.connections(),
  [WorkspaceElementType.Customer]: routeTo.customers(),
  [WorkspaceElementType.Flow]: routeTo.flows(),
  [WorkspaceElementType.FlowInstance]: routeTo.flowInstances(),
  [WorkspaceElementType.FlowRun]: routeTo.flowRuns(),
  [WorkspaceElementType.Action]: routeTo.actions(),
  [WorkspaceElementType.ActionInstance]: routeTo.actionInstances(),
  [WorkspaceElementType.DataSource]: routeTo.dataSources(),
  [WorkspaceElementType.DataSourceInstance]: routeTo.dataSourceInstances(),
  [WorkspaceElementType.FieldMapping]: routeTo.fieldMappings(),
  [WorkspaceElementType.FieldMappingInstance]: routeTo.fieldMappingInstances(),
  [WorkspaceElementType.ExternalEventSubscription]:
    routeTo.externalEventSubscriptions(),
  [WorkspaceElementType.AppEventType]: routeTo.appEventTypes(),
  [WorkspaceElementType.AppEventSubscription]: routeTo.appEventSubscriptions(),
}

export const WORKSPACE_ELEMENT_STATE_TO_COLOR_PALETTE = (
  state: WorkspaceElementState,
) => {
  switch (state) {
    case WorkspaceElementState.READY:
      return 'success'
    case WorkspaceElementState.SETUP_FAILED:
      return 'error'
    case WorkspaceElementState.CONFIGURATION_ERROR:
      return 'error'
    default:
      return 'info'
  }
}
